
/**
 * 
 * @param {alarmed: Boolean, armed: Boolean, attached: Boolean} socketStates 
 */
export const getStateCamFromSocket = (socketStates) => {
  const {alarmed, armed, attached} = socketStates
  if (alarmed && attached) {
    return 'ALARMED'
  }
  if ( !alarmed && !armed && attached ) {
    return 'DISARMED'
  }
  if (!alarmed && armed && attached) {
    return 'ARMED'
  }
  if (!alarmed && armed && !attached) {
    return 'DETACHED'
  }
  if (!alarmed && !armed && !attached) {
    return 'DISARM_DETACHED'
  }
}

export const getDate = (local = 'ru') => {
  const numberLengthCheck = num => !num ? '00' : `${num}`.length < 2 ? `0${num}` : num

  const getMonth = date => {
    if (!date) return ''
    const longStringMonth = date.toLocaleString(local, { month: 'long' })
    let sliceMonth = longStringMonth.slice(0, 3)
    if (sliceMonth === 'май') {
      sliceMonth = sliceMonth.slice(0, 2) + 'я'
    }
    const firstL = sliceMonth.slice(0, 1).toUpperCase()
    const secondL = sliceMonth.slice(1, 3).toLowerCase()
    return firstL + secondL
  }

  const date = new Date('01.01.2022')
  const day = numberLengthCheck(date.getDate())
  const month = getMonth(date)
  const year = date.getFullYear()
  const hours = numberLengthCheck(date.getHours())
  const minutes = numberLengthCheck(date.getMinutes())
  const seconds = numberLengthCheck(date.getSeconds())
  return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`
}


// WEBPACK FOOTER //
// ./src/utils.js